import { useRef } from 'react';

/**
 * useRef with initialize function
 * @param fn
 * @return {React.MutableRefObject<undefined>}
 */
export const useLazyRef = (fn) => {
	const ref = useRef();
	if (ref.current === undefined) ref.current = fn();
	return ref;
};

export default useLazyRef;
